/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "channelInjectionDefs",
    graphQL: "ChannelInjectionDef",
    name: "Channel Page Injection Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'channelInjectionDefs',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Channel Injection ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
        },
        developersNotes: {
            name: "Developer's notes",
            type: "text",
            defaultValue: "",
        },
        addonStyle: {
            name: "Added style",
            description: "CSS Style added to iframe wrapper (example: margin-top: 1em; z-index: 2;).",
            type: "string",
            trim: true,
            defaultValue: "",
        },
        addonClass: {
            name: "Added Class",
            description: "CSS Class added to iframe wrapper.",
            type: "string",
            trim: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] === 'inject'; },
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "inject",
            values: {
                "append-to-page": {
                    name: "Append to page"
                },
                "inject": {
                    name: "Inject into page"
                },
            }
        },
        injectAt: {
            name: "Inject At",
            type: "enum",
            defaultValue: "begin",
            visibility: (data) => { return data['type'] === 'inject'; },
            values: {
                "begin": {
                    name: "Begining of container"
                },
                "end": {
                    name: "End of container"
                },
                "before": {
                    name: "Before that container"
                },
                "after": {
                    name: "After that container"
                },
            }
        },
        containerId: {
            name: "Container Query",
            description: "Query: identifier=#id, class=.className, tag name=body, children=.parentClass .childrenClass, direct children=.parentClass > .childrenClass, multiple classes=.class1.class2",
            type: "string",
            trim: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] === 'inject'; },
        },
        containerType: {
            name: "Container Type",
            type: "enum",
            defaultValue: "query",
            visibility: (data) => { return data['type'] === 'inject'; },
            values: {
                "id": {
                    name: "ID"
                },
                "class": {
                    name: "Class"
                },
                "tag": {
                    name: "Tag Name"
                },
                "query": {
                    name: "jQuery like"
                },
            }
        },
        orientation: {
            name: "Orientation",
            type: "enum",
            defaultValue: "horizontal",
            values: {
                "horizontal": {
                    name: "Horizontal"
                },
                "vertical": {
                    name: "Vertical"
                },
            }
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        spaceInjection: {
            name: "Space injection",
            description: "Allows to append space to bottom of page/div",
            to: () => types['channelInjectionDefs'],
            type: "relation",
            relativeTo: ['channelDef'],
            visibility: (data) => { return data['type'] === 'append-to-page'; },
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
